import React, { Component } from 'react';
import { connect } from 'react-redux';
import setOpenMobileMenu from '../../actions/setOpenMobileMenu';
import { inject, observer } from 'mobx-react';

class MobileMenuToggler extends Component {
  render() {
    return (
      <div className="cell s-shrink h-dn">
        <div className="menuSquare tac up12 pointer splice"  onClick={()=>{ this.props.setOpenMobileMenu(!this.props.mobile_menu_open); }}>
          <div className="cell s-12 s-middle ">
            <i className=" mdi mdi-menu fs30"></i>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    mobile_menu_open:state.mobile_menu_open,
  }
}

// export default connect(mapStateToProps,{ setOpenMobileMenu })(MobileMenuToggler);
export default observer(MobileMenuToggler);